import gql from 'graphql-tag';

const GET_EMERGENCY_CONTACTS_LIST_BY_WORKSPACE_ID = gql`
  query GetEmergencyContactListByWorkspaceId($workspaceId: ID!) {
    getEmergencyContactListByWorkspaceId(workspaceId: $workspaceId) {
      emergencyContactLists {
        id
        name
        workspaceId
      }
    }
  }
`;

export default {
  GET_EMERGENCY_CONTACTS_LIST_BY_WORKSPACE_ID,
};
